import React from 'react';

interface TabNavProps {
  active: string;
  tabs: string[];
  onSelect: (tab: string) => void;
}

const TabNav: React.FC<TabNavProps> = ({ active, tabs, onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onSelect(tab)}
          className={`px-4 py-2 rounded font-bold ${
            active === tab ? 'bg-black text-white' : 'bg-gray-200 hover:bg-gray-300'
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default TabNav;
